import { LogoMark } from "@/components/shared/logo";
import { cn } from "@/lib/utils";

/**
 * To'liq ekran yuklovchi. Spinner o'rniga logotip: kutish vaqti
 * qisqa bo'lsa ham brend ko'rinadi, va bo'sh oq ekran hosil bo'lmaydi.
 */
export function PageLoader({ className }: { className?: string }) {
  return (
    <div className={cn("flex min-h-dvh items-center justify-center", className)}>
      <LogoMark className="text-primary size-10 animate-pulse" />
    </div>
  );
}
